Currency.money_with_currency_format = {
  USD: "$amount USD",
  EUR: "€amount EUR",
  GBP: "£amount GBP",
  CAD: "$amount CAD",
  ARS: "$amount ARS",
  AUD: "$amount AUD",
  BBD: "$amount Bds",
  BDT: "Tk amount BDT",
  BSD: "BS$amount BSD",
  BHD: "amount0 BHD",
  BRL: "R$ amount BRL",
  BOB: "Bsamount BOB",
  BND: "$amount BND",
  BGN: "amount лв BGN",
  MMK: "Kamount MMK",
  KYD: "$amount KYD",
  CLP: "$amount CLP",
  CNY: "¥amount CNY",
  COP: "$amount COP",
  CRC: "₡ amount CRC",
  HRK: "amount kn HRK",
  CZK: "amount Kč",
  DKK: "kr.amount",
  DOP: "RD$ amount",
  XCD: "EC$amount",
  EGP: "LE amount EGP",
  XPF: "amount XPF",
  FJD: "FJ$amount",
  GHS: "GH₵amount",
  GTQ: "amount GTQ",
  GYD: "$amount GYD",
  GEL: "amount GEL",
  HKD: "HK$amount",
  HUF: "amount Ft",
  ISK: "amount kr ISK",
  INR: "Rs.amount",
  IDR: "Rp amount",
  NIS: "amount NIS",
  JMD: "$amount JMD",
  JPY: "¥amount JPY",
  JOD: "amount0 JOD",
  KZT: "amount KZT",
  KES: "KShamount",
  KWD: "amount0 KWD",
  LVL: "Ls amount LVL",
  LTL: "amount Lt",
  MXN: "$ amount MXN",
  MYR: "RMamount MYR",
  MUR: "Rs amount MUR",
  MDL: "amount MDL",
  MAD: "Dh amount MAD",
  MNT: "amount MNT",
  MZN: "Mt amount MZN",
  ANG: "amount NAƒ",
  NZD: "$amount NZD",
  NGN: "₦amount NGN",
  NOK: "kr amount NOK",
  OMR: "amount OMR",
  PKR: "Rs.amount PKR",
  PYG: "Gs. amount PYG",
  PEN: "S/. amount PEN",
  PHP: "₱amount PHP",
  PLN: "amount zl PLN",
  QAR: "QAR amount",
  RON: "amount lei RON",
  RUB: "рубamount RUB",
  SAR: "amount SAR",
  RSD: "amount RSD",
  SGD: "$amount SGD",
  SYP: "S£amount SYP",
  ZAR: "R amount ZAR",
  KRW: "₩amount KRW",
  LKR: "Rs amount LKR",
  SEK: "amount kr SEK",
  CHF: "SFr. amount CHF",
  TWD: "$amount TWD",
  THB: "amount ฿ THB",
  TZS: "amount TZS",
  TTD: "$amount TTD",
  TRY: "amountTL",
  UAH: "₴amount UAH",
  AED: "Dhs. amount AED",
  UYU: "$amount UYU",
  VEB: "Bs. amount VEB",
  VND: "amount VND",
  ZMK: "ZMKamount",
};

const currencyPicker = document.getElementById("currency-picker");
const currencyCodes = Object.keys(Currency.rates).sort();

currencyCodes.forEach((currencyCode) => {
  const isBaseCurrency = currencyCode === Currency.base;
  const isFormattedCurrency =
    Currency.money_with_currency_format.hasOwnProperty(currencyCode);

  if (isBaseCurrency || !isFormattedCurrency) {
    return;
  }

  const option = document.createElement("option");
  option.value = currencyCode;
  option.text = currencyCode;
  currencyPicker.appendChild(option);
});

var savedSelection = window.localStorage.getItem("currency");
if (
  !savedSelection ||
  !Currency.money_with_currency_format.hasOwnProperty(savedSelection)
) {
  window.localStorage.setItem("currency", "USD");
}

currencyPicker.value = window.localStorage.getItem("currency");

const observer = new MutationObserver((mutations) => {
  var shouldUpdatePrices = false;
  mutations.forEach((mutation) => {
    if (mutation.type === "childList") {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (
            node.classList.contains("money") ||
            node.querySelector(".money")
          ) {
            shouldUpdatePrices = true;
          }
        }
      });
    }
  });

  if (shouldUpdatePrices) {
    updatePrices();
  }
});

const observerConfig = {
  childList: true,
  subtree: true,
};

function updatePrices() {
  observer.disconnect();

  const moneyElements = document.querySelectorAll("span.money");
  const currentCurrency = window.localStorage.getItem("currency");

  console.log("Setting prices to: " + currentCurrency);

  moneyElements.forEach(function (moneyElement) {
    if (!moneyElement.dataset.priceInUsd) {
      storeOriginalPrice(moneyElement);
    }

    const priceInUSD = parseFloat(moneyElement.dataset.priceInUsd);
    const priceConverted = Currency.convert(priceInUSD, "USD", currentCurrency);
    const priceFormat =
      Currency.money_with_currency_format[currentCurrency] ||
      `amount ${currentCurrency}`;
    const priceResult = priceFormat
      .replace(/amount/, priceConverted.toFixed(2))
      .trim();

    var elementSign = moneyElement.querySelector(".sign");
    if (elementSign) {
      elementSign.textContent = "";
    }

    var elementCode = moneyElement.querySelector(".code");
    if (elementCode) {
      elementCode.textContent = "";
    }

    moneyElement.querySelector(".amount").textContent = priceResult;
  });

  observer.observe(document.body, observerConfig);
}

function storeOriginalPrice(moneyElement) {
  const amountElement = moneyElement.querySelector(".amount");
  const priceInUSD = parseFloat(amountElement.textContent);
  moneyElement.dataset.priceInUsd = priceInUSD;
}

currencyPicker.addEventListener("change", function (event) {
  window.localStorage.setItem("currency", event.target.value);
  updatePrices();
});

updatePrices();
